import React, { useState } from 'react';
import Image from 'next/image';
import classNames from 'classnames';

import styles from './index.module.scss';

interface StepProps {
  title: string;
  description: string;
  image: string;
}

interface DataProps {
  title: string;
  steps: StepProps[];
}

interface IProps {
  data: DataProps;
}

const StepsWithImage: React.FC<IProps> = ({ data }) => {
  const [activeStep, setActiveStep] = useState<StepProps>(data?.steps[0]);

  return (
    <div
      className={`wrapper ${styles.stepsWrapper}`}
      itemScope
      itemType='https://schema.org/Article'
    >
      <h2 className={styles.mobileTitle}>{data?.title}</h2>
      <div className={styles.imageWrapper}>
        <Image
          src={activeStep?.image}
          layout='responsive'
          width={670}
          height={670}
          alt='step image'
        />
      </div>
      <div className={styles.stepsContainer}>
        <div className={styles.steps}>
          <h2>{data?.title}</h2>
          {data?.steps?.map((step, index) => {
            return (
              <div
                onMouseEnter={() => {
                  setActiveStep(step);
                }}
                key={step?.title}
                className={classNames(styles.stepItem, {
                  [styles.active]: step?.title === activeStep?.title,
                })}
              >
                <div className={styles.left}>{index + 1}</div>
                <div className={styles.right}>
                  <p className={styles.title}>{step.title}</p>
                  <p className={styles.description}>{step.description}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default StepsWithImage;
